import React from "react";
import { DateTime } from "luxon";

interface LomavisDateTimeFormatter1Props {
  /** ISO datetime string, e.g. "2025-09-18T05:57:53.456880-05:00" */
  dateTimeStr: string;
  /** Whether to use short format (e.g. "9.9.25, 11:05") */
  shortFormat?: boolean;
}

/**
 * Atoms: LomavisDateTimeFormatter1
 * Formats an ISO datetime string while preserving the original timezone
 */
export const LomavisDateTimeFormatter1: React.FC<LomavisDateTimeFormatter1Props> = ({
                                                                                      dateTimeStr,
                                                                                      shortFormat = false,
                                                                                    }) => {
  // get language from <html lang="..."> or default to "de"
  const lang =
    document.getElementsByTagName("html")[0]?.getAttribute("lang") || "de";

  // parse datetime with timezone preserved
  const dt = DateTime.fromISO(dateTimeStr.replace(" ", "T"), { setZone: true });

  // choose format depending on flag
  const format = shortFormat ? "d.M.yy, H:mm" : "d. LLL yyyy, H:mm";

  // format nicely for the given locale
  const formatted = dt.setLocale(lang).toFormat(format);

  return <>{formatted}</>;
};
